module.exports = __webpack_public_path__ + "static/img/logo78.134bddd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo78.png
// module id = 6zFE
// module chunks = 1